import Papa from "papaparse";
import constants from "../../core/constants";
import { formatKey } from "../../core/utils";

class Controller {
  constructor(
    $scope,
    $stateParams,
    CaptainAppVersionTransforms,
    CaptainApp,
    Events
  ) {
    "ngInject";

    this.$scope = $scope;
    this.versionId = $stateParams.id;
    this.Events = Events;
    this.CaptainApp = CaptainApp;
    this.CaptainAppVersionTransforms = CaptainAppVersionTransforms;

    this.files = [];
    this.isAppFormDisabled = true;
    this.md5Pattern = constants.RegExp.md5;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.onCaptainAppUploadEvent = Events.getAddEvent("captainAppVersion");
    this.onUpdateEvent = this.Events.getUpdateEvent("captainAppVersion");
    this.onAddFileEvent = this.Events.getAddEvent("captainAppVersion");
    this.uploadDoneEvent = this.Events.getAddEvent("captainAppVersion");
    this.updateApp = this.updateApp.bind(this);
  }

  $onInit() {
    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
    this.Events.on(this.onAddFileEvent, this.initCaptainsTable.bind(this));
    this.Events.on(this.uploadDoneEvent, this.displayCSVStatus.bind(this));

    this.CaptainApp.get(this.versionId).$promise.then(
      this.handleSuccess.bind(this),
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  handleSuccess(response, key) {
    this.captainAppVersion = this.CaptainAppVersionTransforms.justify(response);

    if (key) {
      this.Events.emit(this.successNotificationEvent, {
        message: `${formatKey(key)} has been updated successfully`,
      });
    }
  }

  onUpdate({ key, value }) {
    this.CaptainApp.update(this.versionId, { [key]: value }).$promise.then(
      (response) => {
        this.handleSuccess(response, key);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  updateApp() {
    const data = {
      md5: this.captainAppVersion.md5.value,
      aws_key: this.captainAppVersion.aws_key.value,
    };
    this.CaptainApp.update(this.versionId, data).$promise.then(
      (response) => {
        this.isAppFormDisabled = true;
        this.handleSuccess(response, "App");
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  initCaptainsTable(files) {
    Papa.parse(files[0].source, {
      delimiter: ",",
      complete: ({ data, errors }) => {
        this.$scope.$apply(() => {
          if (errors.length > 0) {
            this.Events.emit(this.errorNotificationEvent, {
              message: errors.map((err) => err.message).join(", "),
            });
          } else {
            const [headers, ...trs] = data;
            this.captainsTable = {
              headers,
              trs: trs.map((tr) => ({ values: tr, lineResponse: null })),
            };
          }
        });
      },
    });
  }

  displayCSVStatus(response) {
    if (response.some((record) => record.status === "fail")) {
      this.Events.emit(this.errorNotificationEvent, {
        message:
          "Some captains are not successfully whitelisted, please check the table to know more!",
      });
    }

    this.captainsTable.headers.push("Status");
    response.forEach((record) => {
      this.captainsTable.trs[record.line - 2].lineResponse = record;
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersion/captainAppVersion.controller.js